module.exports = __webpack_public_path__ + "fonts/iconfont.f12ae7ec.woff";